var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-programmer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-programmer:not(.animated) .animable {opacity: 0;}svg#freepik_stories-programmer.animated #freepik--Plant--inject-47 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-programmer.animated #freepik--Code--inject-47 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-47",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "252.816px 236.869px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,322.12c-47.67-14.69-156.81-49.18-136-146,24-111.84,156.22-36,237.33-73.84,57.41-26.77,177.25-55,168.45,65.86-8.56,117.56-13.47,202.73-83.13,222.94S259.09,344.32,187,322.12Z",
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "252.816px 236.869px"
    },
    id: "elnh2salidht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln4gggcetqc8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,322.12c-47.67-14.69-156.81-49.18-136-146,24-111.84,156.22-36,237.33-73.84,57.41-26.77,177.25-55,168.45,65.86-8.56,117.56-13.47,202.73-83.13,222.94S259.09,344.32,187,322.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "252.816px 236.869px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-47",
    className: "animable",
    style: {
      transformOrigin: "250px 408.51px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 43.22,
    y1: 408.51,
    x2: 456.78,
    y2: 408.51,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "250px 408.51px"
    },
    id: "elez7uo6htjuj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-47",
    className: "animable animator-active",
    style: {
      transformOrigin: "107.788px 323.945px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114,294.51c6,5,4,34.4,22.76,21.75s-13.2-20.14-11.38-27.31c2.56-10,44.77,2,37.69-17.2s-32.32,9.68-38.95,2.53c-6.1-6.58,24.28-30.36,10.12-34.4S123.09,270.23,114,270.23c-7.1,0-5.77-32.88-18.82-21.25s15.47,23.1,11.74,30.32c-2.84,5.49-25.29-8.06-24.28,4.59S107.6,289.22,114,294.51Z",
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "123.238px 279.472px"
    },
    id: "elq559skcvtpe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,279.47S104.36,296,105.88,341.05",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "111.881px 310.26px"
    },
    id: "elwf30019kev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.63,302.9c-2.42-4.87-22.49-8.2-11-18.77s11.45,12.09,16.56,12c7.15-.12,5.76-30.42,17.56-22.6s-11.66,20.19-7.9,25.78c3.45,5.15,24.27-11.49,24.74-1.32s-22.18,2.64-23.63,8.77c-1.13,4.77,21.19,9.11,11.29,16s-13.07-14.07-18.51-12.71c-4.15,1,1.39,18.29-6.95,15.59S147.17,308,144.63,302.9Z",
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "157.351px 299.083px"
    },
    id: "elk351lje23ad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgkpkg8x7xz8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.63,302.9c-2.42-4.87-22.49-8.2-11-18.77s11.45,12.09,16.56,12c7.15-.12,5.76-30.42,17.56-22.6s-11.66,20.19-7.9,25.78c3.45,5.15,24.27-11.49,24.74-1.32s-22.18,2.64-23.63,8.77c-1.13,4.77,21.19,9.11,11.29,16s-13.07-14.07-18.51-12.71c-4.15,1,1.39,18.29-6.95,15.59S147.17,308,144.63,302.9Z",
    style: {
      opacity: 0.3,
      transformOrigin: "157.351px 299.083px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155,303.11s-38.87-4.05-42.71,37.94",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "133.645px 322.027px"
    },
    id: "ela6u7rcjwil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.84,298.56c-6,5-4,34.4-22.76,21.75S71.29,300.16,69.46,293c-2.55-10-44.77,2-37.68-17.2s32.31,9.69,39,2.53c6.09-6.57-24.28-30.35-10.12-34.4s11.11,30.36,20.23,30.36c7.1,0,5.78-32.89,18.83-21.25s-15.48,23.1-11.74,30.32c2.83,5.49,25.29-8.06,24.28,4.58S87.21,293.27,80.84,298.56Z",
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "71.6359px 283.521px"
    },
    id: "elgghsbliifzu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvjc6bubjw8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.84,298.56c-6,5-4,34.4-22.76,21.75S71.29,300.16,69.46,293c-2.55-10-44.77,2-37.68-17.2s32.31,9.69,39,2.53c6.09-6.57-24.28-30.35-10.12-34.4s11.11,30.36,20.23,30.36c7.1,0,5.78-32.89,18.83-21.25s-15.48,23.1-11.74,30.32c2.83,5.49,25.29-8.06,24.28,4.58S87.21,293.27,80.84,298.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "71.6359px 283.521px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.54,283.52s17.7,23.64,21.75,63.09",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "87.415px 315.065px"
    },
    id: "elt208ul43p5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.21,408.34h27.6A10.18,10.18,0,0,0,127,399l4.34-51a10.18,10.18,0,0,0-10.14-11H84.87a10.17,10.17,0,0,0-10.13,11l4.34,51A10.17,10.17,0,0,0,89.21,408.34Z",
    style: {
      fill: "rgb(1, 255, 234)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "103.04px 372.67px"
    },
    id: "el1g5b1xw57e2",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-47",
    className: "animable",
    style: {
      transformOrigin: "283.412px 269.967px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.88,335.1c-9.23,0-35.87-6-35.87-6h71.74S305.1,335.1,295.88,335.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.88px 332.1px"
    },
    id: "elevpd6u0gf59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.66,
    y: 332.09,
    width: 16.44,
    height: 11.27,
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.88px 337.725px"
    },
    id: "elb54bka76yun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.23,
    y: 343.36,
    width: 21.3,
    height: 48.45,
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.88px 367.585px"
    },
    id: "elrgh8gt3gwvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.89,314.71H322c1.54-9.54,2.68-19.26,3.38-28.89h13.84C338.56,295.45,337.43,305.17,335.89,314.71Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "330.61px 300.265px"
    },
    id: "elkkp64hhsd0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,200.48H297.24c-7,0-11.61,5.93-10.25,12.91a453.67,453.67,0,0,1,6.82,64.54,11.15,11.15,0,0,0,11.25,11.2H355.3a13.1,13.1,0,0,0,12.83-11.2,448.82,448.82,0,0,0,2.62-64.54C370.42,206.41,363.93,200.48,356.92,200.48Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "328.862px 244.805px"
    },
    id: "elrlm845ihzvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.17,213.39a448.82,448.82,0,0,1-2.62,64.54,13.1,13.1,0,0,1-12.83,11.2H305.06a11.15,11.15,0,0,1-11.25-11.2A453.67,453.67,0,0,0,287,213.39c-1.36-7,3.23-12.91,10.25-12.91h49.09C353.35,200.48,359.84,206.41,360.17,213.39Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "323.577px 244.805px"
    },
    id: "eloquns0wbam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.75,400.51a1.78,1.78,0,0,1-2.16,1.74c-6.53-1.42-26.08-5.54-33.71-5.54s-27.19,4.12-33.72,5.54a1.77,1.77,0,0,1-2.15-1.74h0a4.67,4.67,0,0,1,3.69-4.57c7.64-1.64,25.07-5.21,32.18-5.21s24.54,3.57,32.18,5.21a4.68,4.68,0,0,1,3.69,4.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.88px 396.511px"
    },
    id: "elbl1muolz7zo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,396.91a6.14,6.14,0,1,0,6.13,6.13A6.14,6.14,0,0,0,260,396.91Zm0,9.46a3.33,3.33,0,1,1,3.32-3.33A3.33,3.33,0,0,1,260,406.37Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "259.99px 403.05px"
    },
    id: "elugldcmv6i4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,396.91A6.14,6.14,0,1,0,302,403,6.14,6.14,0,0,0,295.88,396.91Zm0,9.46A3.33,3.33,0,1,1,299.2,403,3.33,3.33,0,0,1,295.88,406.37Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.86px 403.05px"
    },
    id: "el6rayla2gjlt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,396.91a6.14,6.14,0,1,0,6.14,6.13A6.13,6.13,0,0,0,331,396.91Zm0,9.46a3.33,3.33,0,1,1,3.33-3.33A3.33,3.33,0,0,1,331,406.37Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "331px 403.05px"
    },
    id: "elrajrnihyl88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.06,312.77a473.09,473.09,0,0,1-71.69-3.17,7.5,7.5,0,0,0-8.83,7.59v1.17a10.55,10.55,0,0,0,8.83,10.16,474.39,474.39,0,0,0,71.69,3.17Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "273.799px 320.703px"
    },
    id: "elwjcc79g4soe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,328.21c-14.86,1.86-29.59,3.09-44.55,3.73a6.41,6.41,0,0,1-6.61-6.45v-5.75a6.78,6.78,0,0,1,6.61-6.71c15-.65,29.69-1.88,44.55-3.74a5.54,5.54,0,0,1,6.56,5.61v5.75A7.88,7.88,0,0,1,351.66,328.21Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "329.361px 320.569px"
    },
    id: "elrcnka0a5vq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.17,406c0-3.34-.73-10-4.67-18.65l-5.13-18.5-16,6.83,4.5,14.17s-13.75,6.56-18.83,8.33c-3.38,1.18-13.5,3.5-13,7.84h0a2.33,2.33,0,0,0,2.33,2.33h48.46A2.33,2.33,0,0,0,252.17,406Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "225.596px 388.6px"
    },
    id: "elvyyljpejm7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,395.17c-2.5,1.84-15.83,4.17-12.49,1.5s0-6.83,0-6.83-13.75,6.56-18.83,8.33c-3.38,1.18-13.5,3.5-13,7.84a2.33,2.33,0,0,0,2.33,2.33h48.46a2.32,2.32,0,0,0,2.33-2.35,44.13,44.13,0,0,0-3.06-14.78C246.35,391.24,245.86,393.34,243.36,395.17Z",
    style: {
      fill: "rgb(1, 255, 234)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "225.591px 399.09px"
    },
    id: "elg6g71pup6pq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.74,408.34h35.5a1.53,1.53,0,0,0,1.5-1.24c.54-2.82.42-9.13-2.78-17.51l-.32-17-18.18,3.09,2.3,14.5s-7.32,8.06-10.8,9.5c-2.44,1-8,1.12-8.74,7A1.52,1.52,0,0,0,263.74,408.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "281.599px 390.465px"
    },
    id: "eltepz0im6d5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,395.24c-3.75,2.62-6.52,2.93-4.77-1s-5.43-4.07-5.43-4.07-7.32,8.06-10.8,9.5c-2.44,1-8,1.12-8.74,7a1.52,1.52,0,0,0,1.52,1.7h35.5a1.53,1.53,0,0,0,1.5-1.24c.54-2.82.42-9.13-2.78-17.51C295.22,390.26,295.72,392.61,292,395.24Z",
    style: {
      fill: "rgb(1, 255, 234)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "281.637px 398.995px"
    },
    id: "elh7l0tywana8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.21,278.51s-3.58,3.66-18.21,6-45,9.66-44.63,21.66,28.34,76,28.34,76,14-2.66,20.5-6.66c0,0-11.27-45.67-19.72-57.67,0,0,37.93-4.67,58.91-13.33s8.64-28.4,8.64-28.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "247.506px 329.14px"
    },
    id: "el8zrlkpb2q1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,276.82s5.38,9,1.36,14-26.85,14.33-24.27,25.67,11.1,27.33,16.65,65.33c0,0,12.93-2,21.59-5.67,0,0,1.44-38.66-8.61-55.33,0,0,28.78-5.33,31.7-15s-2.54-24.45-2.65-29.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "292.083px 328.955px"
    },
    id: "eldquqyxwfsai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.7,291.14a13.32,13.32,0,0,0-2,0",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "265.7px 291.121px"
    },
    id: "elzi6zp6j5hfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,285.17s5.91,1.74,8.23,9.45a.62.62,0,0,1-1,.62,14.26,14.26,0,0,0-5.69-3.58",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "272.123px 290.277px"
    },
    id: "el9oeh8lpha4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,317.42c0-3.25-14-5-10.25-8s12.25,6.75,12.25,6.75",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "219.266px 313.133px"
    },
    id: "elf4ubdjjmzo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5,330.42c0-3.72-13.38-5.75-12.71-9.75s9.17,3.88,9.17,3.88",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "286.133px 324.979px"
    },
    id: "el5qm4tjndwyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.23,382.4l1.47,3.4a.88.88,0,0,0,1,.51c3.23-.73,16.71-3.91,21.44-7.31a.85.85,0,0,0,.32-.9l-.92-3.79a.87.87,0,0,0-1.27-.56c-2.13,1.16-8.06,3.93-21.45,7.45A.89.89,0,0,0,224.23,382.4Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "236.325px 379.986px"
    },
    id: "elt7sd4yxmsgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.15,379.6a.69.69,0,0,1,.91-.75,8.79,8.79,0,0,0,5,.07c3.71-.84,14.32-4.2,17.48-5.21a.69.69,0,0,1,.9.66v4.42a.68.68,0,0,1-.41.63c-2.48,1.11-15.77,6.8-22.72,5.25a.68.68,0,0,1-.52-.58Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "288.291px 379.307px"
    },
    id: "el60bcjz0vexl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,287a7,7,0,0,1-1.45,3.8c-2.94,3.65-15.87,9.6-21.66,17",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "275.295px 297.4px"
    },
    id: "elsinlbts9tu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.22,282a16,16,0,0,1,.51,2.25",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "286.475px 283.125px"
    },
    id: "elk0nd2ukbuv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.64,400.42a17.08,17.08,0,0,1,1.75,4.75H247.5a6.38,6.38,0,0,1,2-4.12",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "229.57px 402.795px"
    },
    id: "elxvkp10ji8od",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.39,400.42s5,.38,6.87,4.75h18.88a12.28,12.28,0,0,0,1-4.12",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "285.765px 402.795px"
    },
    id: "eluccsgj20z8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,222c.46,1.76.94,3.51,1.42,5.22,5,18,11.5,52.25,11.5,52.25,32,6.75,65.75,0,65.75,0,.18-7.46-.73-17.31-1.74-27.66,5.24-1.45,9-6.29,9.24-14.34.25-9.75-1.52-27.3-2.5-35.5-.87-7.21-.25-11.5-11.42-17-5.6-3.23-14.9-4.76-26.33-6.29-22.5-3-38.74,1.55-44.5,4-4.57-1.2-5.84,4.16-5.84,4.16-2.53-1.91-5.47,6.19-5.47,6.19-7.4,9.44-13.22,25.34-15.16,31a6.62,6.62,0,0,1-2.26,3.11c-5.25,4-2.33,8.95-2.33,8.95l10.75,3.29s5.21,1.36,9.19-5.49C236.41,228.17,241.85,218.46,242.79,222Z",
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "270.662px 230.08px"
    },
    id: "elu9wkqdn3ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "231.539px 228.198px"
    },
    id: "elq17bm9rlgj",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elndtp3tnvnhq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.88,234.87s-.25-5-4.25-5.87,1.12-2.37,4.25-1.62,2.4-2,5.08-6.5,4-8.06,6.26-5.47,4.61,3,5.57,6.54-3.79,12-3.79,12l-7.46,5.79-3.79,2.12H222.1l-1.94-4.89Z",
    style: {
      opacity: 0.3,
      transformOrigin: "231.539px 228.198px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,222c.46,1.76.94,3.51,1.42,5.22,5,18,11.5,52.25,11.5,52.25,32,6.75,65.75,0,65.75,0,.18-7.46-.73-17.31-1.74-27.66,5.24-1.45,9-6.29,9.24-14.34.25-9.75-1.52-27.3-2.5-35.5-.87-7.21-.25-11.5-11.42-17-5.6-3.23-14.9-4.76-26.33-6.29-22.5-3-38.74,1.55-44.5,4-4.57-1.2-5.84,4.16-5.84,4.16-2.53-1.91-5.47,6.19-5.47,6.19-7.4,9.44-13.22,25.34-15.16,31a6.62,6.62,0,0,1-2.26,3.11c-5.25,4-2.33,8.95-2.33,8.95l10.75,3.29s5.21,1.36,9.19-5.49C236.41,228.17,241.85,218.46,242.79,222Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "270.662px 230.08px"
    },
    id: "el0px1i74rer1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluij4nftwbs9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.46,279.42a180.78,180.78,0,0,0-.95-19.24c1.09,15.23-30.62,20-31.62,11.74s30.83-20.16,13.51-16c-15.11,3.63-44.4.16-51.6-.78,2.77,13,4.91,24.28,4.91,24.28C287.71,286.17,321.46,279.42,321.46,279.42Z",
    style: {
      opacity: 0.3,
      transformOrigin: "286.131px 268.741px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmnuxgmq1fj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.92,202.92s-4.53,13.25-4.52,20.25-12.69,11.7-12.72,11.7c6.81-1.38,13.43-3.21,16.59-4.13a2.43,2.43,0,0,0,1.76-2.55,243.84,243.84,0,0,1-1.11-25.27Z",
    style: {
      opacity: 0.3,
      transformOrigin: "298.86px 218.895px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,199.59a53.94,53.94,0,0,0,3.33,18.29.86.86,0,0,1-1.3,1c-1.72-1.23-4.15-3.73-6.34-8.77",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "238.136px 209.312px"
    },
    id: "el0sgzpr7cb76",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.46,240.42c-2.64-8.75-7.21-10.94-10.75-11.16a.56.56,0,0,1-.26-1c2.06-1.11,6.07-2,11,3.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "317.845px 233.923px"
    },
    id: "eltoc947ktiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.73,215.38a1.51,1.51,0,0,1-3,0,1.51,1.51,0,1,1,3,0Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "271.23px 215.206px"
    },
    id: "elemoy1411lg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.76,232.4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,274.76,232.4Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "273.26px 232.4px"
    },
    id: "el2kov7yc85j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.79,273.42a1.51,1.51,0,1,1-1.51-1.5A1.51,1.51,0,0,1,279.79,273.42Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "278.28px 273.43px"
    },
    id: "elj4clkubqkog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.07,243.55s-4.91,4.68-2.57,4.76,5.29-3.14,8-3.51-1.67-2-1.67-2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "252.626px 245.556px"
    },
    id: "elimim4ljekc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,238.28a2.15,2.15,0,0,0-1.63-.54c-2.4.2-9.3.72-11.9.56-4.62-.29-18.23-3.17-18.23-3.17a2.14,2.14,0,0,0-.94.05l-8.43,2.48a2,2,0,0,0-.82.47l-5.1,4.68a2.18,2.18,0,0,0-.42.54l-1.06,1.94a2.08,2.08,0,0,0,.37,2.49h0L240,248a2,2,0,0,0,1.42-.5l2.5-2.14a2.28,2.28,0,0,0,.43-.5c.61-1,3-4.3,6.7-4,0,0-8,4.25-6.49,6s7.63-3.25,9.63-2.75,2.13,5.41,13,3.63a3.42,3.42,0,0,1,1.46.07l9.9,2.77a2.29,2.29,0,0,0,2.83-1.64C282.15,246.1,282.83,241.1,279.74,238.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.492px 242.881px"
    },
    id: "elk8qrc1kcefq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.16,236.92l-2.12.36a5.7,5.7,0,0,0-2.79,1.32L242,240.53a5.9,5.9,0,0,0-1,1.17l-1.45,2.21a5.25,5.25,0,0,1-.53.69c-.86,1-3.23,3.77-.67,3.39",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "243.177px 242.473px"
    },
    id: "ell7ivdyreq1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.19,237.67l-2.19.6a4,4,0,0,0-1.82,1l-1.71,1.64a3,3,0,0,0-.45.5l-2.81,3.73s-1.5,2.64,0,2.69",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "238.367px 242.75px"
    },
    id: "elyan9wg2zez",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,200.8a229.57,229.57,0,0,0,1,27.39,2.43,2.43,0,0,1-1.76,2.55A187.39,187.39,0,0,1,282,236.19",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.005px 218.495px"
    },
    id: "elvdpav3ujqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,194.6c-.13,1-.24,2.09-.32,3.2",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "307.32px 196.2px"
    },
    id: "elxk3j9h8z87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.83,185.24c-1.14,1-2,2.81-2.59,5.21",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "309.535px 187.845px"
    },
    id: "elwfx4cllhzin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.76,179.3s.63-2,4-3.13,15.06-2.92,21.07,0-5.5,18.81-5.5,18.81L275,202.36l-4.75,3.56-2.12-6.33-2.75-2.86s-5.94-4.87-5.44-9.68S260.76,179.3,260.76,179.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "273.739px 190.252px"
    },
    id: "el6jobx9ut1qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.27,178.88c-.94-3.29-5.23-4.21-5.23-4.21-20.5-3.5-24.83,4-24.83,4a30.18,30.18,0,0,0,0,21s5.83-2.42,6.83,0,2.83,7.58,2.83,7.58A23.12,23.12,0,0,0,277,201c3.17-4.17,10.61,0,10.61,0C292.43,192.67,290.27,178.88,290.27,178.88Zm-5-.24c-7.94,24.92-14.94,26-14.94,26-2.33-9.16-4.33-7.16-7.5-12.89-2.54-4.6-1.68-10.42-1.24-12.55a1.75,1.75,0,0,1,.9-1.2c7.88-4,17.52-2.53,21.49-1.66A1.78,1.78,0,0,1,285.31,178.64Z",
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "274.539px 190.495px"
    },
    id: "el3jlt36fswjz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "274.539px 190.495px"
    },
    id: "eljvsefnpm5tf",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elk2w0hl68jap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.27,178.88c-.94-3.29-5.23-4.21-5.23-4.21-20.5-3.5-24.83,4-24.83,4a30.18,30.18,0,0,0,0,21s5.83-2.42,6.83,0,2.83,7.58,2.83,7.58A23.12,23.12,0,0,0,277,201c3.17-4.17,10.61,0,10.61,0C292.43,192.67,290.27,178.88,290.27,178.88Zm-5-.24c-7.94,24.92-14.94,26-14.94,26-2.33-9.16-4.33-7.16-7.5-12.89-2.54-4.6-1.68-10.42-1.24-12.55a1.75,1.75,0,0,1,.9-1.2c7.88-4,17.52-2.53,21.49-1.66A1.78,1.78,0,0,1,285.31,178.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "274.539px 190.495px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M290.27,178.88c-.94-3.29-5.23-4.21-5.23-4.21-20.5-3.5-24.83,4-24.83,4a30.18,30.18,0,0,0,0,21s5.83-2.42,6.83,0,2.83,7.58,2.83,7.58A23.12,23.12,0,0,0,277,201c3.17-4.17,10.61,0,10.61,0C292.43,192.67,290.27,178.88,290.27,178.88Zm-5-.24c-7.94,24.92-14.94,26-14.94,26-2.33-9.16-4.33-7.16-7.5-12.89-2.54-4.6-1.68-10.42-1.24-12.55a1.75,1.75,0,0,1,.9-1.2c7.88-4,17.52-2.53,21.49-1.66A1.78,1.78,0,0,1,285.31,178.64Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "274.539px 190.495px"
    },
    id: "ellk7nj6vbv2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.8,140.8s-17.67,3.54-7.94,15C259.65,168.57,256.8,140.8,256.8,140.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "251.538px 149.979px"
    },
    id: "elk36gm0s4u7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,168.84s-4.2-17,3.8-25.17,16.67-9.83,23.17-5.83S286,151.84,285,157s-.52,23.66-9.43,31.33-14.39,5.78-20.28-4.67C251.38,176.81,249.53,174.84,249.83,168.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "266.965px 164.384px"
    },
    id: "elar6yfyde5o7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.8,165.51s-6.72-6.67-8.78-14.5-3.22-9.17-10.89-5.34-19.63-1.32-16.5-11c3.29-10.16,13.34,3,23-.33s16.53,2.67,16.54,11.5c0,0,5.84,5.67,0,20.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "265.442px 148.457px"
    },
    id: "elryn28lasou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.69,164.39s1.7-9.32,6.42-8.46,1.35,14.62-4.21,13.12",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.021px 162.519px"
    },
    id: "elz9uwh4tl75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.22,167.55s-1.86,8.65-1.25,10.13,6.32.35,6.32.35",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "258.069px 172.996px"
    },
    id: "elap10ozwdaw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.09,181.8s4.48,1.77,8.43-4.12",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "266.305px 179.865px"
    },
    id: "elcg33d6iqe9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.15,168.27c.16.8-.05,1.53-.47,1.62s-.91-.49-1.08-1.3,0-1.53.47-1.62S253,167.46,253.15,168.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.37px 168.43px"
    },
    id: "elab8pbt0n86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.11,167.39c.17.8,0,1.53-.47,1.62s-.9-.5-1.07-1.3,0-1.53.47-1.62S264,166.58,264.11,167.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.34px 167.55px"
    },
    id: "el10wqywmk574",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.45,167.89c.23,2.27-2,4.35-5.08,4.65s-5.68-1.28-5.91-3.55,2.16-3.26,5.2-3.57S255.23,165.63,255.45,167.89Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "249.955px 168.957px"
    },
    id: "elkl8n9i6yo2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.6,166.48c.23,2.26-2.05,4.35-5.08,4.65s-5.68-1.29-5.91-3.55,2.16-3.27,5.2-3.57S269.38,164.21,269.6,166.48Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "264.105px 167.549px"
    },
    id: "elp3cyapeswo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.45,
    y1: 167.89,
    x2: 258.61,
    y2: 167.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "257.03px 167.735px"
    },
    id: "elo85ire93gte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.22,
    y1: 165.34,
    x2: 280.84,
    y2: 158.49,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "275.03px 161.915px"
    },
    id: "elbl6t9z2196s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.83,
    y1: 176.01,
    x2: 283.38,
    y2: 177.34,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.105px 176.675px"
    },
    id: "elyazyn6gg1is",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9,164.24s1.77-2.25,3.94-1.17",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "250.87px 163.508px"
    },
    id: "el0ehg3ltw3a1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,163.23s-3.11-3-6.11-.88",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "263.945px 162.411px"
    },
    id: "eltlbe8bccnbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.83,135.8c4.73,1.5,12.69,3.34,19.19,1.37,10-3,6.57,8.2,8.82,11.29",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "266.835px 142.13px"
    },
    id: "elmiy8h7greb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.73,134.3s.79.35,2.14.83",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "249.8px 134.715px"
    },
    id: "eltm3dgqqrjns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.68,141.37c.53-.16,1.08-.35,1.66-.57",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "261.51px 141.085px"
    },
    id: "elppig7903o3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,140.05s2.12,3.27,8.94,1.82",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "254.3px 141.145px"
    },
    id: "elmi59ytzhy1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.23,146.46a24.12,24.12,0,0,0,4.24,10.71",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "277.35px 151.815px"
    },
    id: "ela2voamw21z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,142.92a15.9,15.9,0,0,0,.06,1.79",
    style: {
      fill: "none",
      stroke: "rgb(127, 127, 127)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "275.028px 143.815px"
    },
    id: "el22qc7wrs20y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el824lkpylw4k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.86,250.2a1.16,1.16,0,0,0,.74,2.05c6.76,0,25,.08,32-.33,8.75-.5,2.07-10-5-6.38C305.19,248.89,291.55,243.31,283.86,250.2Z",
    style: {
      opacity: 0.3,
      transformOrigin: "302.104px 248.488px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.71,240.82s4.09-10.89,14.35-9.16,2.42,10.32-2.52,11.08C219.54,242.74,218.79,239.75,207.71,240.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "217.397px 237.107px"
    },
    id: "elg7w4y2gbt7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,247c-1.35,1.35-4.6,1.47-2.41-1.46a15.49,15.49,0,0,1,7-5.17c4.86-2.17,6.76-1.73,11.16-2.7s5.23.83,6.75,1.66c3.63,2,4.5,2.34,5.42,4.34s1.92,4.6-.92,4.6c-2.58,0-2.75-4.27-5.25-4.1s-3.75,4.1-5.5,4.1h-.66c-1.5,0-1.58-1.25-.67-3.21s1.92-3.73,1.92-3.73a7.67,7.67,0,0,0-3.38,3.55c-1.2,2.55-1.42,3.62-3.63,3.62s-2-1.64.14-5.26a8.54,8.54,0,0,0-3.05,3.13c-1.08,2-1.65,1.9-3.06,1.9-1.86,0-1.73-3.06,1.56-5.06C204.44,243.21,203.71,242.31,199,247Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "211.861px 242.945px"
    },
    id: "elrc9pub4ymt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.88,239.69s-1.29-.06-2.11,2.12",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "210.825px 240.75px"
    },
    id: "elt2ak3gs4to",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-47",
    className: "animable",
    style: {
      transformOrigin: "250.782px 136.81px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.2,145.54a205.73,205.73,0,0,1,18.41,16.34",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "385.405px 153.71px"
    },
    id: "el636elxxgo4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,140.29c1.22.88,2.44,1.77,3.64,2.68",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "371.04px 141.63px"
    },
    id: "el3veysbkin6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.25,135.5q1.88,1.23,3.74,2.52",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "364.12px 136.76px"
    },
    id: "el5nxtx94dceh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.09,111.3a202.57,202.57,0,0,1,47.1,21.59",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "334.64px 122.095px"
    },
    id: "el0bxoa9gepbfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.17,108.22q3,.77,6.05,1.62",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "303.195px 109.03px"
    },
    id: "ely4w1h0ncy2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.93,105.73q3.3.63,6.58,1.38",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "292.22px 106.42px"
    },
    id: "eltqu2p4tv64",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.92,104.06q2.85.41,5.68.88",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "281.76px 104.5px"
    },
    id: "eln46xjkkylc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,104.46a205.57,205.57,0,0,1,56-1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "246.61px 103.236px"
    },
    id: "ellfmfhnobzg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.36,105.91c1.7-.33,3.41-.65,5.11-.94",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "212.915px 105.44px"
    },
    id: "elkzw6ue3ukfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.35,107.66c1.71-.41,3.41-.79,5.13-1.15",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "204.915px 107.085px"
    },
    id: "eli9adhj1fi6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.51,110.28c1.74-.51,3.48-1,5.23-1.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "195.125px 109.55px"
    },
    id: "elga5sosuzz5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,138.89A202.66,202.66,0,0,1,187,112",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "160px 125.445px"
    },
    id: "el8jcimbxdq5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,144.82q2.34-1.81,4.73-3.56",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "127.365px 143.04px"
    },
    id: "elgnxpe0cuqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.9,151.42c1.71-1.48,3.45-2.92,5.2-4.33",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "119.5px 149.255px"
    },
    id: "elpysi01c6drc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.64,161.88q3.52-3.52,7.16-6.83",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "109.22px 158.465px"
    },
    id: "el1s3m1rvxvip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq23x2jmmd3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 158.96,
    cy: 125.35,
    r: 24.88,
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "158.96px 125.35px",
      transform: "rotate(-76.59deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "158.96px 125.35px"
    },
    id: "eltx680czi7e",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "el6ew9q9vihvh"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 158.96,
    cy: 125.35,
    r: 24.88,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "158.96px 125.35px",
      transform: "rotate(-76.59deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elivs98t8te8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 158.96,
    cy: 125.35,
    r: 24.88,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "158.96px 125.35px",
      transform: "rotate(-76.59deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147,135.13V128.9c0-1.56-.44-2-2.13-2v-3.05c1.69,0,2.13-.47,2.13-2v-6.23a3.47,3.47,0,0,1,3.76-3.76h1.9v3h-.55c-1.18,0-1.79.54-1.79,2.41v5.07a2.81,2.81,0,0,1-2.07,3v.07a2.81,2.81,0,0,1,2.07,3v5.08c0,1.86.61,2.4,1.79,2.4h.55v3h-1.9A3.47,3.47,0,0,1,147,135.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "148.765px 125.375px"
    },
    id: "el2n7d3vp9mbw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.23,135.84h.54c1.19,0,1.8-.54,1.8-2.4v-5.08a2.82,2.82,0,0,1,2.06-3v-.07a2.81,2.81,0,0,1-2.06-3v-5.07c0-1.87-.61-2.41-1.8-2.41h-.54v-3h1.9a3.47,3.47,0,0,1,3.76,3.76v6.23c0,1.56.44,2,2.13,2v3.05c-1.69,0-2.13.47-2.13,2v6.23a3.47,3.47,0,0,1-3.76,3.76h-1.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "169.125px 125.325px"
    },
    id: "elb7b1huwo6o5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.45,
    y: 157.11,
    width: 38.27,
    height: 38.27,
    rx: 11.96,
    style: {
      fill: "rgb(1, 255, 234)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "103.585px 176.245px"
    },
    id: "el5g1a1pir6cv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.71,177.17v-1.85l7.65-3.3v2l-5.27,2.23,5.27,2.22v2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "93.535px 176.245px"
    },
    id: "elzebg7z16td",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,167.5h2.38l-6.9,17.5H98.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "103.58px 176.25px"
    },
    id: "elaqciuklqxmw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8,178.47l5.27-2.22L109.8,174v-2l7.65,3.3v1.85l-7.65,3.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "113.625px 176.225px"
    },
    id: "el6bgjszvntfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli0383u1wv3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 335.46,
    cy: 119.72,
    r: 21.23,
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "335.46px 119.72px",
      transform: "rotate(-76.84deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "335.46px 119.72px"
    },
    id: "elf1mf9dcwfrq",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elwou0m2y8lwq"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 335.46,
    cy: 119.72,
    r: 21.23,
    style: {
      opacity: 0.2,
      transformOrigin: "335.46px 119.72px",
      transform: "rotate(-76.84deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elgaicb0pvnt9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 335.46,
    cy: 119.72,
    r: 21.23,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "335.46px 119.72px",
      transform: "rotate(-76.84deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.33,124.12v-8.8c0-2.53,1.31-4,3.79-4s3.79,1.49,3.79,4v1.73h-2.43v-1.89c0-1.08-.52-1.52-1.29-1.52s-1.28.44-1.28,1.52v9.14c0,1.08.51,1.5,1.28,1.5s1.29-.42,1.29-1.5v-2.5h2.43v2.32c0,2.52-1.31,4-3.79,4S322.33,126.64,322.33,124.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "326.12px 119.72px"
    },
    id: "elx29hj2xecg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27,120.63h-3.14V118.8h3.14v-3.15h1.82v3.15h3.14v1.83h-3.14v3.2h-1.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "335.18px 119.74px"
    },
    id: "eljbqr01j2emc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.63,120.63h-3.14V118.8h3.14v-3.15h1.82v3.15h3.14v1.83h-3.14v3.2h-1.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "344.54px 119.74px"
    },
    id: "el6j2n2mflpeo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.28,
    y: 78.24,
    width: 46.39,
    height: 46.39,
    rx: 13.6,
    style: {
      fill: "rgb(1, 255, 234)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "244.475px 101.435px"
    },
    id: "elj0tsuvb49uo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.53,106.32V96.55c0-2.81,1.46-4.47,4.21-4.47S239,93.74,239,96.55v1.92h-2.7V96.36c0-1.19-.58-1.68-1.43-1.68s-1.43.49-1.43,1.68v10.16c0,1.2.57,1.67,1.43,1.67s1.43-.47,1.43-1.67v-2.78H239v2.58c0,2.8-1.46,4.46-4.21,4.46S230.53,109.12,230.53,106.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "234.765px 101.43px"
    },
    id: "elv10lgssmgsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,106.21v-1h2.7v1.25c0,1.3.57,1.77,1.48,1.77s1.48-.47,1.48-1.82c0-1.51-.57-2.47-2.44-4.11-2.39-2.1-3.17-3.58-3.17-5.66,0-2.86,1.48-4.52,4.26-4.52s4.16,1.66,4.16,4.57v.75H246v-.93c0-1.3-.52-1.79-1.43-1.79s-1.42.49-1.42,1.74.59,2.28,2.46,3.92c2.39,2.1,3.15,3.56,3.15,5.82,0,3-1.51,4.62-4.32,4.62S240.23,109.12,240.23,106.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "244.495px 101.47px"
    },
    id: "elcxma0atkoda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,106.21v-1h2.7v1.25c0,1.3.57,1.77,1.48,1.77s1.48-.47,1.48-1.82c0-1.51-.57-2.47-2.44-4.11-2.39-2.1-3.17-3.58-3.17-5.66,0-2.86,1.48-4.52,4.26-4.52s4.16,1.66,4.16,4.57v.75h-2.71v-.93c0-1.3-.52-1.79-1.43-1.79s-1.42.49-1.42,1.74.59,2.28,2.46,3.92c2.39,2.1,3.15,3.56,3.15,5.82,0,3-1.51,4.62-4.32,4.62S249.9,109.12,249.9,106.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "254.16px 101.47px"
    },
    id: "el9atlkn58jtm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljcwkzygl7z"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 164.63,
    r: 21.18,
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "391.6px 164.63px",
      transform: "rotate(-76.59deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "391.6px 164.63px"
    },
    id: "elybtmabt0ey",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elg05yt2mis8b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 164.63,
    r: 21.18,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "391.6px 164.63px",
      transform: "rotate(-76.59deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el6gpwpcu14hl"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 164.63,
    r: 21.18,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "391.6px 164.63px",
      transform: "rotate(-76.59deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.27,168.83v-8.41c0-2.41,1.25-3.84,3.62-3.84s3.62,1.43,3.62,3.84v1.66h-2.32v-1.81c0-1-.5-1.46-1.23-1.46s-1.23.43-1.23,1.46V169c0,1,.49,1.43,1.23,1.43s1.23-.4,1.23-1.43v-2.39h2.32v2.21c0,2.41-1.25,3.84-3.62,3.84S383.27,171.24,383.27,168.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "386.89px 164.62px"
    },
    id: "ellgpb8hfa4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,168h-1.1l.18-1.74h1.1l.42-4.09H392l.18-1.75h1.12l.38-3.6h1.94l-.38,3.6h1.59l.38-3.6h1.95l-.38,3.6h1.14l-.18,1.75h-1.14l-.43,4.09h1.14l-.18,1.74H398l-.47,4.47h-1.94l.47-4.47h-1.59l-.47,4.47h-1.94Zm3.71-1.74.42-4.09h-1.58l-.43,4.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px",
      transformOrigin: "395.675px 164.645px"
    },
    id: "elzxyj9x0qll",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-47",
    className: "animable",
    style: {
      transformOrigin: "252.445px 307.09px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "141.23 408.51 137.52 408.51 136.52 261.25 141.23 261.25 141.23 408.51",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "138.875px 334.88px"
    },
    id: "el4yuvp0ofy03",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.93 408.51 141.23 408.51 141.23 261.25 145.93 261.25 144.93 408.51",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "143.58px 334.88px"
    },
    id: "eljehva0z1aie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.78,
    y: 252.24,
    width: 254.21,
    height: 9.02,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "225.885px 256.75px"
    },
    id: "elbauk3jpx4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.19,
    y: 252.24,
    width: 56.92,
    height: 9.02,
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "377.65px 256.75px"
    },
    id: "elrbwitkk9py",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.8,
    y: 261.25,
    width: 252.72,
    height: 14.86,
    style: {
      fill: "rgb(1, 255, 234)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "238.16px 268.68px"
    },
    id: "elksukeyguaoa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el13vzz2h7ne2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.52,
    y: 261.25,
    width: 29.43,
    height: 14.86,
    style: {
      fill: "rgb(1, 255, 234)",
      transformOrigin: "379.235px 268.68px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "379.235px 268.68px"
    },
    id: "elhsigu7pgjv9",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elrp2nzzhk6j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.52,
    y: 261.25,
    width: 29.43,
    height: 14.86,
    style: {
      opacity: 0.3,
      transformOrigin: "379.235px 268.68px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el3npsuxsjcag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.52,
    y: 261.25,
    width: 29.43,
    height: 14.86,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "379.235px 268.68px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "364.52 408.51 360.82 408.51 359.82 261.25 364.52 261.25 364.52 408.51",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "362.17px 334.88px"
    },
    id: "elppo9d5b0qsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.23 408.51 364.52 408.51 364.52 261.25 369.23 261.25 368.23 408.51",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "366.875px 334.88px"
    },
    id: "elnu67f37pgct",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.8 408.51 108.09 408.51 107.09 261.25 111.8 261.25 111.8 408.51",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "109.445px 334.88px"
    },
    id: "elk6odx1wflrg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.5 408.51 111.8 408.51 111.8 261.25 116.5 261.25 115.5 408.51",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "114.15px 334.88px"
    },
    id: "elnslzfzi3ed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.95 408.51 390.24 408.51 389.24 261.25 393.95 261.25 393.95 408.51",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "391.595px 334.88px"
    },
    id: "elfhdpe9619o7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.65 408.51 393.95 408.51 393.95 261.25 398.65 261.25 397.65 408.51",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "396.3px 334.88px"
    },
    id: "eltm6lvyie8ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.05,251.24H233.26a1.11,1.11,0,0,1-1.1-1.11v-2.46l32,1v1.46A1.11,1.11,0,0,1,263.05,251.24Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "248.16px 249.455px"
    },
    id: "elee6j0epaump",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.83,251.24H168.94a2.39,2.39,0,0,1-2.19-1.67l-12.86-41.74a1.58,1.58,0,0,1,1.52-2.16H215.3a2.38,2.38,0,0,1,2.19,1.66l12.86,41.74A1.59,1.59,0,0,1,228.83,251.24Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "192.12px 228.455px"
    },
    id: "elehbdzjc6ao6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,249.07l-12.86-41.74a2.38,2.38,0,0,0-2.19-1.66H215.3a2.38,2.38,0,0,1,2.19,1.66l12.86,41.74a1.59,1.59,0,0,1-1.52,2.17h2.69A1.59,1.59,0,0,0,233,249.07Z",
    style: {
      fill: "rgb(133, 133, 133)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "224.205px 228.455px"
    },
    id: "elfeteod9s7me",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.83,228.45a3.21,3.21,0,0,1-3.25,3.71,4.31,4.31,0,0,1-4.16-3.71,3.2,3.2,0,0,1,3.25-3.7A4.32,4.32,0,0,1,195.83,228.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "192.125px 228.455px"
    },
    id: "elig75l1sc0fj",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.79,222c.46,1.76.94,3.51,1.42,5.22,5,18,11.5,52.25,11.5,52.25,32,6.75,65.75,0,65.75,0,.18-7.46-.73-17.31-1.74-27.66,5.24-1.45,9-6.29,9.24-14.34.25-9.75-1.52-27.3-2.5-35.5-.87-7.21-.25-11.5-11.42-17-5.6-3.23-14.9-4.76-26.33-6.29-22.5-3-38.74,1.55-44.5,4-4.57-1.2-5.84,4.16-5.84,4.16-2.53-1.91-5.47,6.19-5.47,6.19-7.4,9.44-13.22,25.34-15.16,31a6.62,6.62,0,0,1-2.26,3.11c-5.25,4-2.33,8.95-2.33,8.95l10.75,3.29s5.21,1.36,9.19-5.49C236.41,228.17,241.85,218.46,242.79,222Z",
    style: {
      fill: "#01FFEA",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.27,178.88c-.94-3.29-5.23-4.21-5.23-4.21-20.5-3.5-24.83,4-24.83,4a30.18,30.18,0,0,0,0,21s5.83-2.42,6.83,0,2.83,7.58,2.83,7.58A23.12,23.12,0,0,0,277,201c3.17-4.17,10.61,0,10.61,0C292.43,192.67,290.27,178.88,290.27,178.88Zm-5-.24c-7.94,24.92-14.94,26-14.94,26-2.33-9.16-4.33-7.16-7.5-12.89-2.54-4.6-1.68-10.42-1.24-12.55a1.75,1.75,0,0,1,.9-1.2c7.88-4,17.52-2.53,21.49-1.66A1.78,1.78,0,0,1,285.31,178.64Z",
    style: {
      fill: "#01FFEA",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-47"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 158.96,
    cy: 125.35,
    r: 24.88,
    transform: "translate(0.18 250.92) rotate(-76.59)",
    style: {
      fill: "#01FFEA",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-47"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 335.46,
    cy: 119.72,
    r: 21.23,
    transform: "translate(142.51 419.11) rotate(-76.84)",
    style: {
      fill: "#01FFEA",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-47"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 391.6,
    cy: 164.63,
    r: 21.18,
    transform: "translate(140.66 507.38) rotate(-76.59)",
    style: {
      fill: "#01FFEA",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.52,
    y: 261.25,
    width: 29.43,
    height: 14.86,
    transform: "translate(758.47 537.37) rotate(180)",
    style: {
      fill: "#01FFEA",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/homeMain.529a9c762e062487cc26de01b504f4cb.svg";
export { ForwardRef as ReactComponent };